import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/Spinner";

export function AdminOnly({ children }: { children: ReactNode }) {
  const { role, user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <Spinner className="min-h-[40vh]" />;
  }

  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  if (role !== "admin") {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
